<template>
	<BaseCard
		:is-toggleable="true"
		:is-editable="!isProcessFinished && (isUserAllowedInLevel5or6 || isUserAllowedInLevel1)"
		:title="$t('accident_input_data').toString()"
		@clickEdit="$router.push({ name: 'damagecases.edit.accident' })"
		:is-toggle-open="isToggleOpen"
		@toggleCard="toggleCard($event)"
	>
		<BaseCardRow :value="getAccidentDateAndTime" :label="$t('accident_date')" />
		<BaseCardRow v-if="!$store.getters.isProcessComprehensive" :value="damageCase.accidentLocation" :label="$t('accident_location')" />
		<BaseCardRow
			v-if="!$store.getters.isProcessComprehensive"
			:value="damageCase.isRecordedByPolice ? $t('general.yes') : $t('general.no')"
			:label="$t('recorded_by_police')"
		/>
		<BaseCardRow
			v-if="damageCase.oppositeLicensePlate && !$store.getters.isProcessComprehensive"
			:value="damageCase.oppositeLicensePlate.text"
			:label="$t('opponent_license_plate')"
		/>
		<BaseCardRow
			v-if="damageCase.oppositePerson && !$store.getters.isProcessComprehensive"
			:value="damageCase.oppositePerson.firstName + ' ' + damageCase.oppositePerson.lastName"
			:label="$t('opponent_name')"
		/>
		<BaseCardRow v-if="!$store.getters.isProcessComprehensive" :value="isPersonInjured" :label="$t('injured_by_accident')" />
	</BaseCard>
</template>
<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow';
import { concatArray, getStringFromDate, getTimeWithLeadingNull } from '@/plugins/Utils';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'AccidentCard',
	components: { BaseCard, BaseCardRow },
	mixins: [Authentication],
	props: {
		damageCase: {},
		isProcessFinished: {},
		isToggleOpen: { type: Boolean, default: true },
	},
	computed: {
		isDamageTimeSetByUser() {
			return this.damageCase.damageTimeSetByUser;
		},
		getAccidentDateAndTime() {
			if (this.isDamageTimeSetByUser && this.dateToString && !this.$store.getters.isProcessComprehensive) {
				return this.dateToString + ' - ' + this.getAccidentTime;
			} else {
				return this.dateToString;
			}
		},
		isPersonInjured() {
			return this.damageCase.isPersonInjured ? this.$t('general.yes') : this.$t('general.no');
		},
		getAccidentTime() {
			let hours = this.getDate.getHours();
			let minutes = this.getDate.getMinutes();

			if (!Number.isInteger(minutes) || !Number.isInteger(hours)) {
				return '';
			}

			minutes = getTimeWithLeadingNull(minutes);
			hours = getTimeWithLeadingNull(hours);

			return hours + ':' + minutes + ' ' + this.$t('o_clock');
		},
		getDate: function() {
			return this.damageCase?.date ? new Date(this.damageCase?.date * 1000) : null;
		},
		dateToString: function() {
			return this.getDate ? getStringFromDate(this.getDate) : null;
		},
		getStringFromDateWrapper: function(date) {
			return getStringFromDate(date);
		},
	},
	methods: {
		toggleCard($event) {
			this.$emit('toggleCard', $event);
		},
	},
};
</script>
